<template>
    <div class="home-swiper">
        <!-- 轮播容器 -->
        <div class="swiper-container" :class="joinType" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
            <!-- 轮播轨道 -->
            <div class="swiper-track"
                :style="{ transform: `translateX(-${currentIndex * 100}%)`, transition: transitionDuration }">
                <div class="swiper-slide" v-for="(item, index) in displayList" :key="index">
                    <div class="slide-content" :class="`bg-img-${joinType}`">
                        <img :src="item.img" :alt="item.alt || '轮播内容'" class="content-img">
                    </div>

                </div>
            </div>
        </div>
        <div class="swper-box" :class="`box-${joinType}`" v-if="displayList.length > 0">
            <div class="join-title">
                {{ displayList[currentIndex].title }}
                <div class="join-tips">

                    {{ displayList[currentIndex].tips }}
                </div>
            </div>
            <div class="box-btn-box">
                <img src="https://youke1.picui.cn/s1/2025/08/27/68af0900e0b9e.png" class="control-btn" alt="上一页"
                    @click="prevSlide">
                <img src="https://youke1.picui.cn/s1/2025/08/27/68af0900d4f3f.png" class="control-btn" alt="下一页"
                    @click="nextSlide">
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps, watch } from 'vue'

// 接收父组件参数
const props = defineProps({
    goodList: {
        type: Array,
        default: () => [],
        required: true
    },
    joinType: {
        type: String,
        default: 'left' // left/right
    }
})

// 轮播核心状态
const displayList = ref([]) // 用于展示的动态数组
const currentIndex = ref(0) // 当前显示索引（始终保持0，因为通过数组移位实现切换）
const transitionDuration = ref('transform 0.5s ease-out') // 过渡动画
let timer = null

// 初始化显示数组（复制原始数组）
const initDisplayList = () => {
    if (props.goodList.length > 0) {
        displayList.value = [...props.goodList]
    }
}

// 右滑逻辑：将第一个元素移到最后
const nextSlide = () => {
    if (displayList.value.length <= 1) return

    // 执行动画期间锁定操作
    transitionDuration.value = 'transform 0.5s ease-out'
    currentIndex.value = 1 // 触发右滑动画

    // 动画结束后调整数组
    setTimeout(() => {
        // 保存第一个元素
        const firstItem = displayList.value[0]
        // 删除第一个元素
        displayList.value.splice(0, 1)
        // 添加到数组末尾
        displayList.value.push(firstItem)
        // 重置索引（无动画）
        transitionDuration.value = 'none'
        currentIndex.value = 0
    }, 500)
}

// 左滑逻辑：将最后一个元素移到最前
const prevSlide = () => {
    if (displayList.value.length <= 1) return

    // 先调整数组（无动画）
    transitionDuration.value = 'none'
    // 保存最后一个元素
    const lastItem = displayList.value[displayList.value.length - 1]
    // 删除最后一个元素
    displayList.value.pop()
    // 添加到数组开头
    displayList.value.unshift(lastItem)
    // 触发左滑动画
    currentIndex.value = 1

    // 强制DOM更新后启用动画
    setTimeout(() => {
        transitionDuration.value = 'transform 0.5s ease-out'
        currentIndex.value = 0
    }, 10)
}

// 自动播放
const startAutoPlay = () => {
    if (displayList.value.length <= 1) return
    stopAutoPlay()
    timer = setInterval(nextSlide, 5000)
}

// 暂停自动播放
const stopAutoPlay = () => {
    if (timer) {
        clearInterval(timer)
        timer = null
    }
}

// 监听原始数据变化，重新初始化
watch(() => props.goodList, (newVal) => {
    initDisplayList()
})

// 初始化
onMounted(() => {
    initDisplayList()
    if (displayList.value.length > 1) {
        startAutoPlay()
    }
})

// 组件卸载时清理
onUnmounted(() => {
    stopAutoPlay()
})

// 计算属性：根据方向设置内容位置
const contentPosition = {
    left: { left: '0' },
    right: { right: '0' }
}[props.joinType]
</script>

<style scoped>
.join-title {
    color: #F4ECE1;
    font-size: 36px;
    font-weight: bold;
    margin-top: 150px;
    text-align: center;
    line-height: 1.5;
}

.join-tips {
    color: #6A584E;
    font-size: 18px;
    margin-top: 5px;
    text-align: center;
    line-height: 1.6;
}

.swper-box {
    z-index: 999;
    width: 350px;
    height: 460px;
    background: url("https://youke1.picui.cn/s1/2025/08/30/68b2e2addbd3d.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.box-btn-box {
    position: absolute;
    bottom: 50px;
    width: 30%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
}

.box-left {
    left: 0%;
}

.box-right {
    right: 0%;
}

.home-swiper {
    background-color: #F4ECE1;
    height: 1000px;
    position: relative;
    overflow: hidden;
    width: 80%;
    margin: auto;
}

.swiper-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.swiper-track {
    display: flex;
    height: 100%;
}

.swiper-slide {
    min-width: 100%;
    height: 100%;
    position: relative;
}

.slide-content {
    width: 100%;
    position: absolute;
    top: 80px;
    z-index: 2;
}

.content-img {
    height: 800px;
    width: 90%;
   
}

.control-btn {
    width: 40px;
    height: 40px;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 100;
    transition: transform 0.3s ease;
}

.control-btn:hover {
    transform: translateY(-50%) scale(1.1);
}

.bg-img-left {
    left: 300px;

}

.bg-img-right {}
</style>
